import React from "react";
import "../styles/root.css";
import { useLocale } from "../context/LocaleContext";

function Footer() {
  const currentYear = new Date().getFullYear();
  const { t } = useLocale();

  return (
    <footer className="footer">
      <div className="footer-content">
        <div>
          <h2 className="footer-heading">{t.footer.heading}</h2>
          <ul className="footer-list">
            <li>
              <a href="mailto:anisijainfo@gmail.com">anisijainfo@gmail.com</a>
            </li>
            <li>
              <a
                href="https://www.facebook.com/anisijazkso"
                target="_blank"
                rel="noreferrer"
              >
                facebook.com/anisijazkso
              </a>
            </li>
            <li>
              <a href="tel:+38978831731">+389 78 831 731</a>
            </li>
          </ul>
        </div>
        <p className="footer-copy">
          © {currentYear} Anisija. {t.footer.rights}
        </p>
      </div>
    </footer>
  );
}

export default Footer;
